import type { MailProps } from 'core/utils/mailto';
import mailto from 'core/utils/mailto';

import { FeedbackBox } from './Feedback.styles';
import { FEEDBACK_MAIL_BODY, FEEDBACK_MAIL_SUBJECT, FEEDBACK_MAIL_TO } from './literals';

interface Props {
  email?: MailProps;
}

const defaultEmail = {
  to: FEEDBACK_MAIL_TO,
  subject: FEEDBACK_MAIL_SUBJECT,
  body: FEEDBACK_MAIL_BODY,
};

function Feedback({ email = defaultEmail }: Props) {
  return <FeedbackBox href={mailto(email)}>Support</FeedbackBox>;
}

export default Feedback;
